import React, { useContext, useEffect, useState } from "react";
import ModalAdicion from "./ModalAdicion/ModalAdicion";
import DomiciliosItem from "./DomiciliosItem";
import "./Domicilios.css";

const Domicilios = ({ acreditadoInfo }) => {
  const [showModal, setShowModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [currentDirList, setCurrentDirList] = useState([]);
  useEffect(() => {
    const listDir = [];
    listDir.push({
      Tipo: 1,
      RFC: acreditadoInfo.Rfcac,
      Nombre: acreditadoInfo.Nombreac,
      Pais: acreditadoInfo.Paisac,
      Estado: acreditadoInfo.Estadoac,
      Ciudad: acreditadoInfo.Ciudadac,
      Municipio: acreditadoInfo.Municipioac,
      Colonia: acreditadoInfo.Coloniaac,
      Codpos: acreditadoInfo.Codposac,
      Domicilio: acreditadoInfo.Domicilioac,
      Tel: acreditadoInfo.Telfam,
      Trabajo: acreditadoInfo.TrabajoAc,
      Puesto: acreditadoInfo.PuestoAc,
      DomTrab: acreditadoInfo.DomTrabAc,
      MuniTrab: acreditadoInfo.MuniTrabAc,
      TelTrab: acreditadoInfo.TelTrabAc,
      AcreditadoId: acreditadoInfo.AcreditadoId,
    });

    listDir.push({
      Tipo: 2,
      RFC: acreditadoInfo.Rfcav,
      Nombre: acreditadoInfo.Nombreav,
      Pais: acreditadoInfo.Paisav,
      Estado: acreditadoInfo.Estadoav,
      Ciudad: acreditadoInfo.Ciudadav,
      Municipio: acreditadoInfo.Municipioav,
      Colonia: acreditadoInfo.Coloniaav,
      Codpos: acreditadoInfo.Codposav,
      Tel: acreditadoInfo.Telav,
      Domicilio: acreditadoInfo.Domicilioav,
      Trabajo: acreditadoInfo.TelTrabAv,
      Puesto: acreditadoInfo.PuestoAv,
      DomTrab: acreditadoInfo.DomTrabAv,
      MuniTrab: acreditadoInfo.MuniTrabAv,
      TelTrab: acreditadoInfo.TelTrabAv,
      AcreditadoId: acreditadoInfo.AcreditadoId,
    });
    setCurrentDirList(listDir);
  }, []);
  function editModal(item){
    setCurrentRow(item);
    setShowModal(true);
  }
  return (
    <div className="Domicilios__container">
      <div className="Domicilios__btncontainer">
        <h1>Domicilio | Principales</h1>
      </div>
      <div className="DomiciliosItems__container">
        {currentDirList.map((item) =>
          item.Domicilio !== "" ? (
            <DomiciliosItem currentRow={item} setCurrentRow={editModal} />
          ) : (
            <div className="btnAgregarDomicilio__container">
              <button className="btnAgregarDomicilio" onClick={()=>{setShowModal(true);setCurrentRow(item)}}>
                No se cuenta con domicilio del {item.Tipo === 1 ? "Acreditado" : "Aval"}
              </button>
            </div>
          )
        )}
      </div>
      
      <ModalAdicion
        setShow={setShowModal}
        show={showModal}
        setCurrentRow={editModal}
        currentRow={currentRow}
        acreditadoInfo={acreditadoInfo}
      />
    </div>
  );
};

export default Domicilios;
